document.addEventListener("DOMContentLoaded", function() {
  // Helper function to create pagination controls
  function createPagination(container, totalItems, itemsPerPage, onPageClick) {
    let totalPages = Math.ceil(totalItems / itemsPerPage);
    container.innerHTML = "";

    function renderPageButtons(currentPage) {
      container.innerHTML = "";

      // Prev button
      const prevBtn = document.createElement("button");
      prevBtn.classList.add("custom-pagination-prev");
      prevBtn.innerHTML = `
  <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 1L2 7L8 13" stroke="#3A3F40" stroke-width="1.5"/>
  </svg>
`;
      prevBtn.disabled = currentPage === 1;
      prevBtn.addEventListener("click", () => {
        if (currentPage > 1) {
          renderPageButtons(currentPage - 1);
          onPageClick(currentPage - 1);
        }
      });
      container.appendChild(prevBtn);

      // Page number buttons
      for (let i = 1; i <= totalPages; i++) {
        const pageBtn = document.createElement("button");
        pageBtn.textContent = i;
        pageBtn.className = i === currentPage ? "active" : "";
        pageBtn.addEventListener("click", () => {
          renderPageButtons(i);
          onPageClick(i);
        });
        container.appendChild(pageBtn);
      }

      // Next button
      const nextBtn = document.createElement("button");
      nextBtn.classList.add("custom-pagination-next");
      nextBtn.innerHTML = `
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L7 7L1 13" stroke="#3A3F40" stroke-width="1.5"/>
      </svg>
      `;
      nextBtn.disabled = currentPage === totalPages;
      nextBtn.addEventListener("click", () => {
        if (currentPage < totalPages) {
          renderPageButtons(currentPage + 1);
          onPageClick(currentPage + 1);
        }
      });
      container.appendChild(nextBtn);
    }

    renderPageButtons(1);
  }

  // Blog articles pagination
  const blogItems = Array.from(document.querySelectorAll(".block__latest_content_box"));
  const blogNumItems = blogItems.length;
  const blogPerPage = 9;

  // Initially hide all beyond first page
  blogItems.forEach((el, idx) => {
    el.style.display = idx < blogPerPage ? "" : "none";
  });

  const blogPaginationWrapper = document.querySelector('.blog-pagination-wrapper');
  if (blogPaginationWrapper) {
    createPagination(blogPaginationWrapper, blogNumItems, blogPerPage, (pageNumber) => {
      const showFrom = blogPerPage * (pageNumber - 1);
      const showTo = showFrom + blogPerPage;

      blogItems.forEach((el, idx) => {
        el.style.display = (idx >= showFrom && idx < showTo) ? "" : "none";
      });

      // // Scroll to top smoothly
      // window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  const openPopupButtons = document.querySelectorAll(".open-popup");
  const closeButtons = document.querySelectorAll("[data-close]");
  
  // Function to pause YouTube videos in a given popup
  function pauseYouTubeInPopup(popup) {
    const iframe = popup.querySelector("iframe");
    if (iframe && iframe.src.includes("youtube.com")) {
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }
  
  // Open popup and lock body scroll
  openPopupButtons.forEach(button => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      const popupId = this.getAttribute("data-popup-id");
      const popup = document.getElementById(popupId);
      popup.style.display = "flex";
      document.body.classList.add("overflow-hidden");
    });
  });
  
  // Close popup and unlock body scroll
  closeButtons.forEach(button => {
    button.addEventListener("click", function () {
      const popup = this.closest(".block__popup");
      popup.style.display = "none";
      pauseYouTubeInPopup(popup);
      document.body.classList.remove("overflow-hidden");
    });
  });
  
  // Close popup on clicking outside and unlock scroll
  document.querySelectorAll(".block__popup").forEach(popup => {
    popup.addEventListener("click", function (e) {
      if (e.target === this) {
        this.style.display = "none";
        pauseYouTubeInPopup(this);
        document.body.classList.remove("overflow-hidden");
      }
    });
  });
  

});


